import { render, staticRenderFns } from "./Tx.vue?vue&type=template&id=28f8c482&scoped=true"
import script from "./Tx.vue?vue&type=script&lang=js"
export * from "./Tx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f8c482",
  null
  
)

export default component.exports